import {ChangeDetectorRef, Component} from '@angular/core';
import {IonicPage, NavController, NavParams, ViewController} from 'ionic-angular';
import {ReaderService} from "../../providers/reader.service";
import {TranslateService} from "@ngx-translate/core";

/**
 * Generated class for the PopoverCyclecountProgressPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-popover-cyclecount-geiger',
  templateUrl: 'popover-cyclecount-geiger.html',
})
export class PopoverCyclecountGeigerPage {

  title = '';
  progress = '0';
  shouldUpdateView = true;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private readerService: ReaderService,
              public translate: TranslateService,
              private cdr: ChangeDetectorRef,
              public viewCtrl: ViewController) {
    this.title = navParams.get('title');
    this.initRecursiveGetProgress();
  }

  ionViewWillLeave() {
    this.shouldUpdateView = false;
  }

  // TODO: CHANGE TO EVENTS
  initRecursiveGetProgress() {
    setTimeout(() => {
      if (this.shouldUpdateView) {
        if (this.readerService.isTriggerPulled) {
          this.progress = String(this.readerService.tagProximity < 100 ? this.readerService.tagProximity : 100);
        } else {
          this.progress = String(0);
        }
        this.cdr.detectChanges();
        this.initRecursiveGetProgress();
      }
    }, 300);
  }

  dismissSelf() {
    this.readerService.tagProximity = 0;
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/popover-cyclecount-geiger/popover-cyclecount-geiger.ts